"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LTFPrivileges = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var LTFPrivileges = (function (_super) {
    __extends(LTFPrivileges, _super);
    function LTFPrivileges() {
        return _super.call(this, {
            name: CardName_1.CardName.LTF_PRIVILEGES,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.MOON],
            cost: 21,
            metadata: {
                cardNumber: 'M82',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When playing a Moon tag, you do not pay additional steel or titanium for playing it.', function (eb) {
                        eb.moon().startEffect.text('0').steel(1).nbsp.text('0').titanium(1);
                    });
                }),
            },
        }) || this;
    }
    ;
    LTFPrivileges.prototype.play = function () {
        return undefined;
    };
    return LTFPrivileges;
}(Card_1.Card));
exports.LTFPrivileges = LTFPrivileges;
//# sourceMappingURL=LTFPrivileges.js.map